import { View, Text, StyleSheet } from 'react-native'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { useTranslation } from 'react-i18next'
import { fonts } from '../lib/theme'
import { useThemeColors } from '../lib/useThemeColors'
import GradientButton from './GradientButton'
import { Skeleton } from './Home/ui'

// Stati comuni delle pagine, uguali ovunque (caricamento, errore con "Riprova", dati non aggiornati).

// Scheletro di una lista: righe con volto, nome e valore. Sostituisce il testo "Caricamento...".
export function ListSkeleton({ rows = 6, header = true }) {
  const tc = useThemeColors()
  const { t } = useTranslation()
  return (
    <View accessible accessibilityLabel={t('common.loading')} accessibilityState={{ busy: true }} style={[s.card, { backgroundColor: tc.bgCard, borderColor: tc.border }]}>
      {header && <Skeleton width={140} height={14} style={{ marginBottom: 16 }} />}
      {Array.from({ length: rows }, (_, i) => (
        <View key={i} style={s.row}>
          <Skeleton width={26} height={14} />
          <Skeleton width={34} height={34} radius={17} />
          <Skeleton width="42%" height={14} />
          <View style={{ flex: 1 }} />
          <Skeleton width={46} height={14} />
        </View>
      ))}
    </View>
  )
}

// Errore con via d'uscita: il messaggio dice che e' un problema di caricamento (non "nessun dato") e c'e' "Riprova".
export function ErrorState({ onRetry, title, message }) {
  const tc = useThemeColors()
  const { t } = useTranslation()
  return (
    <View style={s.error} accessibilityRole="alert">
      <MaterialCommunityIcons name="wifi-alert" size={40} color={tc.textMuted} />
      <Text style={[s.errorTitle, { color: tc.text }]}>{title ?? t('common.load_error_title')}</Text>
      <Text style={[s.errorSub, { color: tc.textMuted }]}>{message ?? t('common.load_error_sub')}</Text>
      {onRetry && <GradientButton onPress={onRetry} size="md" style={{ minWidth: 160, marginTop: 6 }}>{t('common.retry')}</GradientButton>}
    </View>
  )
}

// Striscia discreta quando si mostrano dati salvati perche' l'aggiornamento e' fallito
export function StaleBanner({ onRetry }) {
  const tc = useThemeColors()
  const { t } = useTranslation()
  return (
    <View style={[s.stale, { backgroundColor: tc.rosaSubtle, borderColor: tc.rosaBorder }]} accessibilityRole="alert">
      <MaterialCommunityIcons name="cloud-off-outline" size={16} color={tc.rosaText} />
      <Text style={[s.staleText, { color: tc.text }]} numberOfLines={2}>{t('common.stale_data')}</Text>
      {onRetry && (
        <Text onPress={onRetry} accessibilityRole="button" style={[s.staleRetry, { color: tc.rosaText }]}>{t('common.retry')}</Text>
      )}
    </View>
  )
}

const s = StyleSheet.create({
  card: { borderRadius: 14, borderWidth: 1, padding: 18, marginHorizontal: 16, marginBottom: 16 },
  row: { flexDirection: 'row', alignItems: 'center', gap: 10, minHeight: 46 },
  error: { alignItems: 'center', justifyContent: 'center', padding: 32, gap: 8 },
  errorTitle: { fontFamily: fonts.condensedBold, fontSize: 18, textAlign: 'center', textTransform: 'uppercase' },
  errorSub: { fontSize: 13, lineHeight: 19, textAlign: 'center', maxWidth: 280 },
  stale: { flexDirection: 'row', alignItems: 'center', gap: 8, borderWidth: 1, borderRadius: 10, paddingHorizontal: 12, minHeight: 44, marginHorizontal: 16, marginBottom: 12 },
  staleText: { flex: 1, fontSize: 12 },
  staleRetry: { fontFamily: fonts.condensedBold, fontSize: 13, paddingVertical: 12, paddingLeft: 8, textTransform: 'uppercase' },
})
